import React, { memo } from "react";
import styles from "./DayHeader.module.css";

const DayHeader = memo(({ weekdays }) => {
	return (
		<div className={styles.daysHeader}>
			<div className={styles.periodLabel}>Period</div>
			{weekdays.map((day) => (
				<div
					key={day.dateFormatted}
					className={`${styles.dayHeader} ${day.isToday ? styles.today : ""}`}
				>
					<div className={styles.dayName}>{day.shortName}</div>
					<div className={styles.dayDate}>
						{new Date(day.date).toLocaleDateString("en-US", {
							month: "short",
							day: "numeric",
						})}
					</div>
				</div>
			))}
		</div>
	);
});

export default DayHeader;
